import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '../../utils';
var colors = tokens.colors,
  spacing = tokens.spacing;
export var heading = /*#__PURE__*/css("display:flex;flex-direction:column;align-items:flex-start;align-self:stretch;color:", colors.neutral.heavy.default, ";margin-bottom:", spacing.m, ";", media('>=desktop'), "{margin-bottom:", spacing.s, ";}");
export var title = /*#__PURE__*/css(designTokenFonts.displaySmall, " ", media('>=desktop'), "{", designTokenFonts.heading, "}");
export var subtitle = /*#__PURE__*/css(designTokenFonts.body);